import { render, staticRenderFns } from "./30000004.vue?vue&type=template&id=60f605d7&scoped=true&"
import script from "./30000004.vue?vue&type=script&lang=js&"
export * from "./30000004.vue?vue&type=script&lang=js&"
import style0 from "./30000004.vue?vue&type=style&index=0&id=60f605d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f605d7",
  null
  
)

export default component.exports